import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=36704d96&scoped=true&"
import script from "./footers.vue?vue&type=script&lang=js&"
export * from "./footers.vue?vue&type=script&lang=js&"
import style0 from "./footers.vue?vue&type=style&index=0&id=36704d96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36704d96",
  null
  
)

export default component.exports